<template>
  <div id="terms-agree">
    <comp-header
      :leftIcon="headerLeftIcon"
      :leftClick="goPrevious"
      :pageTitle="headerPageTitle"
    />

    <h5>{{ $t('acc.signUp.terms.privacy') }}</h5>
    <div class="terms">
      <comp-terms-privacy/>
    </div>
    <div class="check-container">
      <input id="privacy" type="checkbox">
      <label v-html="$t('acc.signUp.terms.checkbox')"></label>
    </div>

    <h5>{{ $t('acc.signUp.terms.service') }}</h5>
    <div class="terms">
      <comp-terms-service/>
    </div>
    <div class="check-container">
      <input id="service" type="checkbox">
      <label v-html="$t('acc.signUp.terms.checkbox')"></label>
    </div>

    <form-button
      :btnName="btnName"
      @parentCall="agree"
    />
    <comp-modal
      v-if="showModal"
      @confirm="modalAction"
      titleShow
    >
      <h3 slot="header">{{ $t('error.title') }}</h3>
      <p slot="body">{{ msgModal }}</p>
    </comp-modal>

    <comp-loading
      v-if="isLoading"
    ></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import CompTermsPrivacy from '@/components/CompTermsPrivacy';
import CompTermsService from '@/components/CompTermsService';
import FormButton from '@/components/FormButton';
import CompModal from '@/components/CompModal';
import CompLoading from '@/components/CompLoading';
import RESPONSE from '@/constants/response';
import TEST from '@/constants/test';

export default {
  name: 'terms-agree',
  mixins: [
    common,
  ],
  data() {
    return {
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('acc.signUp.terms.title'),
      headerRightIcon: 'fa-chevron-right',

      btnName: 'Next',
      showModal: false,
      msgModal: this.$i18n.t('acc.signUp.terms.modal'),
      isAuthFailed: false,

      isLoading: false,
    };
  },
  components: {
    CompModal,
    CompLoading,
    FormButton,
    CompHeader,
    CompTermsPrivacy,
    CompTermsService,
  },
  mounted() {
    this.isShowMenu(false);
    this.isLoading = true;

    const code = this.$route.query.code;
    const state = this.$route.query.state;
    if (!code) {
      this.$router.push('/acc/login');
    } else {
      const data = {
        code,
        state,
      };

      this.$store.dispatch('naverAuth', { data })
        .then((result) => {
          const accessToken = result.data.access_token;
          const tokenType = result.data.token_type;

          const tokenData = {
            accessToken,
            tokenType,
          };

          this.$store.dispatch('getNaverProfile', { tokenData })
            .then((response) => {
              if (response.data) {
                const profile = response.data.response;
                const tag = this.$route.query.tag;
                if (tag && tag === 'delete') {
                  this.$store.dispatch('naverDisconnect', accessToken)
                    .then((disconnResult) => {
                      let deleteFlag = '';
                      if (disconnResult.status) deleteFlag = profile.id;
                      this.$router.push({
                        name: 'acc-delete',
                        params: {
                          deleteFlag,
                        },
                      });
                    });
                } else {
                  this.$store.dispatch('setTmpUserEmail', profile.email).then();
                  this.$store.dispatch('setTmpUserName', profile.name).then();
                  this.$store.dispatch('setTmpUserNickname', profile.nickname).then();
                  this.$store.dispatch('setTmpUserPassword', profile.id).then();
                  this.$store.dispatch('setTmpProfileImage', profile.profile_image).then();
                  this.checkSnsId(profile.email, profile.id);
                }
              } else {
                this.$router.push('/acc/login');
              }
            });
        });
    }
  },
  methods: {
    agree() {
      this.isLoading = true;

      const privacy = this.$el.querySelector('#privacy').checked;
      const service = this.$el.querySelector('#service').checked;
      if (privacy && service) {
        const code = this.$route.query.code;
        const state = this.$route.query.state;
        const data = {
          code,
          state,
        };

        this.$router.push({ path: '/acc/signup/sns/naver', query: data });
      } else {
        this.showModal = true;
        this.$el.querySelector('.Button').classList.remove('process');
      }
      this.isLoading = false;
    },
    checkSnsId(email, password) {
      const params = {
        userId: email,
        password,
      };

      this.$store.dispatch('checkSnsUserId', params)
        .then((result) => {
          if (result.status === RESPONSE.SUCCESS.CODE) {
            this.performLogin(email, password);
          } else {
            this.errorCall(result);
          }
        });
    },
    performLogin(email, password) {
      this.$store.dispatch('logIn', { email, password }).then((data) => {
        // 로그인 성공 시, 페이지 이동.
        if (data.status === RESPONSE.SUCCESS.CODE) {
          const qCnt = data.data.qCnt;
          if (qCnt || qCnt === 0) {
            this.$store.dispatch('setQCnt', { qCnt }).then();
            // eslint-disable-next-line
            if (qCnt == TEST.MAXIMUM) {
              this.goPage('/mc6');
            } else {
              this.goPage('/test/intro');
            }
          } else {
            this.invalidateLogin();
          }
        } else {
          this.errorCall(data);
        }
      });
    },
    errorCall(result) {
      if (Object.prototype.hasOwnProperty.call(result, 'error')) {
        if (result.status === RESPONSE.FAIL.CODE && result.error.resultCode === 400) {
          this.msgModal = this.$i18n.t('error.invalid.auth');
        } else if (result.status === RESPONSE.FAIL.CODE && result.error.resultCode === -100) {
          this.isLoading = false;
          return;
        } else {
          this.titleModal = this.$i18n.t('error.title');
          this.msgModal = `[${result.status}:${result.error.resultCode}]
            : ${result.error.resultMsg}`;
        }
      } else if (Object.prototype.hasOwnProperty.call(result, 'data')) {
        this.msgModal = `[${result.status}:${result.data.resultCode}]
          : ${result.data.resultMsg}`;
      } else {
        this.msgModal = this.$i18n.t('error.undefined');
      }
      this.showModal = true;
      this.isAuthFailed = true;
      this.isLoading = false;
    },
    modalAction() {
      if (this.isAuthFailed) {
        this.invalidateLogin();
      } else {
        this.showModal = false;
      }
    },
  },
};
</script>

<style lang="scss" src="../../scss/terms.scss"></style>



// WEBPACK FOOTER //
// src/views/terms/terms-agree.vue